/** Holds the current status code for the ongoing SSR rendering pass.
 *
 *  Changing this value will cause the current rendering to return the given status code.
 */
export const SSRStatus = {
    code: 200,
}
